/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSendFormAnalyticsModel,
  ISendFormAnalyticsRequest,
  IMappers,
  ISendFormAnalyticsResponse,
  ISendFormAnalyticsResponseError,
  TSendFormAnalyticsResponse,
} from './types';

const defaultConfig: TSendFormAnalyticsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'lead-realtor-form',
  pathApi: '/v1/send-form-analytics/',
  hostType: 'api',
} as TSendFormAnalyticsModel;

function createSendFormAnalyticsModel(parameters: ISendFormAnalyticsRequest): TSendFormAnalyticsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISendFormAnalyticsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISendFormAnalyticsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSendFormAnalytics<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISendFormAnalyticsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TSendFormAnalyticsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createSendFormAnalyticsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISendFormAnalyticsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISendFormAnalyticsResponseError);
    }
  }

  return { response, statusCode } as TSendFormAnalyticsResponse;
}

export { defaultConfig, createSendFormAnalyticsModel, fetchSendFormAnalytics };
